module.exports = new __parcel__URL__("OptimismLogo.4bfae879.svg").toString();